/**
 * Register block title property.
 */
import { title } from '@wordpress/icons';
import { edit } from './edit';
import { save } from './save';
import metadata from './block.json';

export const settings = {
    ...metadata,
    icon: title,
    edit,
    save,
};
